import { useParams } from "react-router-dom";
import { useState } from "react";
import AddEditCoachTeamMember from "../../components/add-edit-coach-team-member";
import { individualOrganisationActionType } from "../../core/dictionary/global-enums";
import "../../assets/scss/all-login.scss";

export default function SignupPage({ role }) {
  // role: "coach" | "team-member"  (injected via the route element prop)
  const { organizationId } = useParams();
  const [done, setDone] = useState(false);

  const isCoach = role === "coach";
  const type = isCoach
    ? individualOrganisationActionType.addCoach
    : individualOrganisationActionType.addTeamMember;

  const heading = isCoach ? "Coach Sign Up" : "Team Member Sign Up";
  const subHeading = isCoach
    ? "Complete your profile to join as a Coach."
    : "Complete your profile to join as a Team Member.";

  return (
    <div className="login-page">
      {/* Left branding panel */}
      <div className="login-left">
        <img
          src="https://res.cloudinary.com/dhhzpdckr/image/upload/v1758128880/rescuernlogo_dsi3mf.png"
          alt="RescueRn Logo"
          className="company-logo"
        />
        <h1>RescueRN Academy</h1>
        <p>
          Empowering healthcare professionals with simulation-based
          resuscitation training.
        </p>
      </div>

      {/* Right form panel */}
      <div className={`login-right${done ? "" : " login-right--form"}`}>
        <div className="login-card login-card--signup">
          {done ? (
            <div className="signup-success">
              <div className="signup-success__icon">✓</div>
              <h2 className="signup-success__title">Registration Successful!</h2>
              <p className="signup-success__message">
                Your account has been created. Please check your inbox and follow the next steps.
              </p>
            </div>
          ) : (
            <>
              <h2 className="signup-heading">{heading}</h2>
              <p className="sub signup-subheading">{subHeading}</p>
              <AddEditCoachTeamMember
                type={type}
                organizationId={organizationId}
                onSuccess={() => setDone(true)}
                isSignup
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
